import { FC } from "react";

import { parseOrganizationDashboards } from "./helpers/parseOrganizationDashboards";
import { OrganizationDashboards } from "./OrganizationDashboards";

import { useSwitchOrganization } from "@/common/hooks/useSwitchOrganization";
import type { AssistantToolRendererProps } from "@/features/Assistant/contexts/AssistantConfigContext";
import { useAssistantWidgetContext } from "@/features/Assistant/contexts/AssistantWidgetContext";

export const ConnectedOrganizationDashboards: FC<AssistantToolRendererProps> = ({ part }) => {
  const switchOrganization = useSwitchOrganization();
  const widget = useAssistantWidgetContext();
  const { organizations, guide } = parseOrganizationDashboards(part.state === "output-available" ? part.output : null);
  return (
    <OrganizationDashboards
      organizations={organizations}
      guide={guide}
      onOpen={async (organization) => {
        await switchOrganization(organization.id);
      }}
      onCreate={() => widget?.closePanel()}
    />
  );
};
